module.exports = __webpack_public_path__ + "static/media/changeai.a8be6ed3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/changeai.webp
// module id = 215
// module chunks = 0